import {
  CoverageIndicator
} from '@creditsights/styleguide-web';
import React, { ReactElement } from 'react';
import { EM_DASH } from '../../../Base.constants';
import {
  isCompanyCovered,
  isRpCovered
} from '../../Company/Company.logic';

interface CoverageProp {
  csCoverage: boolean;
  crCoverage: boolean;
  lfiCoverage: boolean;
  financialsCoverage: boolean;
  riskProductsCoverage: boolean;
}

const Coverage = ({ csCoverage, crCoverage, lfiCoverage, financialsCoverage, riskProductsCoverage }: CoverageProp): ReactElement => {
  const isRiskProductsCoverage = isRpCovered({ riskProductsCoverage });

  if (!isCompanyCovered({csCoverage, crCoverage, lfiCoverage, financialsCoverage, riskProductsCoverage})) {
    return <div>{EM_DASH}</div>;
  }

  return <CoverageIndicator csCoverage={csCoverage} lfiCoverage={lfiCoverage} crCoverage={crCoverage} financialsCoverage={financialsCoverage} riskProductsCoverage={isRiskProductsCoverage} />;
}

export default Coverage;
